import type { TicketSection as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/** A shared allotment pool that section-backed tickets draw from — the model's `TicketBucket` (ADR-014 decision 5). */
export type TicketSection = {
  id: number;
  name: string | null;
  color: string;
  quantity: number;
  remaining: number;
  editable: boolean;
  deletable: boolean;
};

export const fromGql = (item: GQLItem): TicketSection => ({
  ...take<TicketSection>(item, 'id', 'color', 'quantity', 'remaining', 'editable', 'deletable'),
  name: item.name ?? null,
});
